import api from "../../Utils/api";
import { format } from "date-fns";
import { toast } from "react-toastify";
import ScheduleDetailsForm from "./ScheduleDetail";

export default function TimesheetDetails({
  schedule,
  locations,
  reloadTimesheets,
}) {
  const timeFormat = (timeStr) => {
    const time = new Date(timeStr);
    time.setFullYear(time.getUTCFullYear());
    time.setMonth(time.getUTCMonth());
    time.setDate(time.getUTCDate());
    time.setHours(time.getUTCHours());
    time.setMinutes(time.getUTCMinutes());
    time.setSeconds(time.getUTCSeconds());
    return time;
  };

  const isWithin15Minutes = (startISO, endISO) => {
    if (!startISO || !endISO) return false;

    const start = new Date(startISO);
    const end = new Date(endISO);

    const diffMs = Math.abs(end - start); // Absolute difference
    const diffMinutes = diffMs / (1000 * 60); // Convert ms to minutes

    return diffMinutes <= 15;
  };

  function checkDayType(isoString) {
    const date = new Date(isoString);
    const day = date.getDay(); // 0 = Sunday, 6 = Saturday

    if (day === 0) return "Sunday";
    if (day === 6) return "Saturday";
    return "Weekday";
  }

  return (
    <div className="pl-12 w-full bg-white">
      {schedule !== undefined && (
        <div className="w-full flex flex-wrap justify-between">
          {schedule.approved ? (
            <table className="w-[calc(100%-350px)] text-sm text-gray-700">
              <tbody>
                <tr className="border-b">
                  <th className="px-4 py-2 text-right w-[200px] font-medium text-gray-600 ">
                    Date
                  </th>
                  <td className="px-4 py-2 ">
                    {schedule?.startTime
                      ? format(
                          timeFormat(schedule.startTime),
                          "EEEEEEE, d, MMMM,  yyyy"
                        )
                      : ""}
                  </td>
                </tr>

                <tr className="border-b">
                  <th className="px-4 py-2 text-right w-[200px] font-medium text-gray-600">
                    Area
                  </th>
                  <td className="px-4 py-2">
                    {"[" +
                      (schedule.locationID?.area || "") +
                      (schedule.locationID?.name
                        ? "]  " + schedule.locationID.name
                        : "")}
                  </td>
                </tr>

                <tr className="border-b">
                  <th className="px-4 py-2 text-right w-[200px] font-medium text-gray-600">
                    Time
                  </th>
                  <td className="px-4 py-2">
                    {schedule?.startTime
                      ? format(
                          timeFormat(schedule.timesheetID.startTime),
                          "hh:mm aa"
                        )
                      : ""}{" "}
                    ~{" "}
                    {schedule?.endTime
                      ? format(
                          timeFormat(schedule.timesheetID.endTime),
                          "hh:mm aa"
                        )
                      : ""}
                    {!isWithin15Minutes(
                      schedule.startTime,
                      schedule.timesheetID.startTime
                    ) ||
                      (!isWithin15Minutes(
                        schedule.endTime,
                        schedule.timesheetID.endTime
                      ) && (
                        <div className="relative group ml-2 inline-block cursor-pointer">
                          <span className="text-red-500">⚠️</span>

                          {/* Tooltip */}
                          <div className="absolute left-full -top-12 -translate-x-1/2 ml-2 w-max max-w-xs bg-gray-700 text-sm text-white rounded-md shadow-md px-3 py-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10">
                            {/* Arrow */}
                            <div className="absolute -bottom-1 left-[90px] w-3 h-3 bg-gray-700 rotate-45 z-[-1]" />
                            <span className="font-semibold">Scheduled</span>:{" "}
                            {schedule?.startTime
                              ? format(
                                  timeFormat(schedule.startTime),
                                  "hh:mm aa"
                                )
                              : ""}{" "}
                            ~{" "}
                            {schedule?.endTime
                              ? format(timeFormat(schedule.endTime), "hh:mm aa")
                              : ""}
                          </div>
                        </div>
                      ))}
                  </td>
                </tr>

                {/* <tr className="border-b">
                  <th className="px-4 py-2 text-right w-[200px] font-medium text-gray-600">
                    Break Summary
                  </th>
                  <td className="px-4 py-2">
                    {schedule?.timesheetID?.breakStartTime
                      ? format(
                          new Date(schedule.timesheetID.breakStartTime),
                          "hh:mm a"
                        )
                      : ""}{" "}
                    ~{" "}
                    {schedule?.timesheetID?.breakEndTime
                      ? format(
                          new Date(schedule.timesheetID.breakEndTime),
                          "hh:mm a"
                        )
                      : ""}
                  </td>
                </tr> */}

                <tr className="border-b">
                  <th className="px-4 py-2 text-right w-[200px] font-medium text-gray-600">
                    Payrates
                  </th>
                  <td className="px-4 py-2">{schedule.timesheetID.payrates}</td>
                </tr>

                <tr className="border-b">
                  <th className="px-4 py-2 text-right w-[200px] font-medium text-gray-600">
                    Paid
                  </th>
                  <td className="px-4 py-2">
                    € {schedule.timesheetID.payAmount} ({" "}
                    {schedule.timesheetID.publicHoliday
                      ? "Public Holiday"
                      : checkDayType(schedule.startTime)}{" "}
                    )
                  </td>
                </tr>

                <tr>
                  <th className="px-4 py-2 text-right w-[200px] font-medium text-gray-600">
                    Time Sheet comment
                  </th>
                  <td className="px-4 py-2">{schedule.timesheetID.comment}</td>
                </tr>
              </tbody>
            </table>
          ) : (
            <div className="w-full">
              <ScheduleDetailsForm
                getTimesheets={reloadTimesheets}
                locations={locations}
                schedule={schedule}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

const statusColors = {
  created: {
    background: "bg-sky-100",
    text: "text-sky-800",
  },
  started: {
    background: "bg-red-100",
    text: "text-red-800",
  },
  pending: {
    background: "bg-orange-300",
    text: "text-orange-900",
  },
  approved: {
    background: "bg-green-100",
    text: "text-green-800",
  },
};

function StatusTag({ status, payAmount }) {
  const lowerStatus = status.toLowerCase();
  const colors = statusColors[lowerStatus] || {
    background: "bg-gray-200",
    text: "text-gray-700",
  };

  return (
    <span
      className={`inline-block px-3 py-1 rounded-full font-light ${colors.background} ${colors.text} select-none`}
      aria-label={`Status: ${status}`}
      role="status"
    >
      {status == "approved" && (
        <span className="mr-2 font-semibold">${payAmount}</span>
      )}
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}
